export class AESKey {

    static key = 'V43HFWE8CpFZ5KvX';
    static iv = 'sXUHcpJJq3hhY9G8';

}